

















































































































































import Vue, { PropType } from 'vue';
import {
  BuyerCompany as Company,
  countries,
} from 'mostra';

export default Vue.extend({
  name: 'GAccountCompany',
  props: {
    company: {
      type: Object as PropType<Company>,
      required: true,
    },
    textAreaRows: {
      type: Number as PropType<number>,
      default: 3,
    },
    underline: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isCheckBoxTwoLines: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    countries: () => countries.options(),
  },
});
